import { getDate, getRandomGuid, isPresent } from './commonUtils';

export const readCookie = (market) => {
  let cookieValue = '';
  window.document.cookie.split(';').forEach((cookieObj) => {
    const localCookieObj = (cookieObj.charAt(0) === ' ') ? cookieObj.substring(1, cookieObj.length) : cookieObj;
    if (market === 'US' && localCookieObj.includes('gctracus=')) {
      cookieValue = (localCookieObj.substring('gctracus='.length, localCookieObj.length)).split('&');
    }
    if (market !== 'US' && localCookieObj.includes('gctrac=')) {
      cookieValue = (localCookieObj.substring('gctrac='.length, localCookieObj.length)).split('&');
    }
  });
  return cookieValue;
};

export const createCookie = (market) => {
  const gctVisitorId = getDate() + getRandomGuid();
  const cookieExpiryDt = new Date();
  const domainName = document.domain;
  cookieExpiryDt.setTime(cookieExpiryDt.getTime() + (2 * 365 * 24 * 60 * 60 * 1000));
  if (market === 'US' && !window.document.cookie.includes('gctracus=')) {
    window.document.cookie = `gctracus=gctvid=${gctVisitorId};expires=${cookieExpiryDt.toGMTString()};path=/;domain=${domainName}`;
  }
  if (market !== 'US' && !window.document.cookie.includes('gctrac=')) {
    window.document.cookie = `gctrac=gctvid=${gctVisitorId}&lno=0;expires=${cookieExpiryDt.toGMTString()};path=/;domain=${domainName}`;
  }
};

export const getVisitorId = (market) => {
  const cookieVal = readCookie(market);
  if (isPresent(cookieVal[0])) return cookieVal[0].replace('\'', '');
  return '';
};

export const getCookie = (name) => {
  const ckParts = (`; ${window.document.cookie}`).split(`; ${name}=`);
  if (ckParts.length >= 2) {
    return decodeURIComponent(ckParts.pop().split(';').shift());
  }
  return '';
};
